import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from '../assets/img/ravenlogo.png';
import { Link } from 'react-router-dom';
import DownloadPlatforms from './DownloadPlatforms';
import SocialMediaContact from './SocialMediaContact';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="tab-1">
        <div className="logo">
          <img src={Logo} alt="" />
        </div>
        <p>
          Raven is a live-streaming and social networking app helping African
          creators earn globally
        </p>
      </div>

      <div className="tab-2">
        <SocialMediaContact />
        <div className="line-divider hide-mobile"></div>

        <div className="user-permission">
          <Link to={'/safety'}>Safety Guidelines</Link>
          <Link to={'/terms'}>Terms of Service</Link>
          <Link to={'/privacy'}>Privacy Policy</Link>
        </div>

        <div className="hide-mobile">
          &copy; 2022 Raven Livestream Technologies Ltd. All rights reserved
        </div>
      </div>

      <div className="tab-3">
        <p>Get the App on</p>

        <DownloadPlatforms />

        <p>Send a mail</p>

        <a href="" className="button contact">
          Contact@ravenlivestream.com
        </a>
      </div>
    </footer>
  );
}
